import { createContext, ReactNode, useContext } from 'react';
import {
    JsxMessage,
    Language,
    languageFromString,
    Message,
} from './Localized.ts';

type LanguageContext = {
    language: Language;
    setLanguage: (lng: Language) => void;
};

const LanguageContextObj = createContext<LanguageContext | null>(null);

export function LanguageProvider({
    context,
    children,
}: {
    context: LanguageContext;
    children: ReactNode;
}) {
    return (
        <LanguageContextObj.Provider value={context}>
            {children}
        </LanguageContextObj.Provider>
    );
}

export function useLanguage(): LanguageContext {
    const context = useContext(LanguageContextObj);
    if (!context) {
        throw new Error('useLanguage must be used within a LanguageProvider');
    }
    return context;
}

export function useTranslation(message: Message): string {
    const { language } = useLanguage();
    return message[languageFromString(language)];
}

export function useLocalize() {
    const { language } = useLanguage();
    return (message: Message) => message[languageFromString(language)];
}

export function Localized(props: Message | JsxMessage) {
    const { language } = useLanguage();
    return <>{props[languageFromString(language)]}</>;
}
